
 import companyName from '../store/mobxStore/companyName';
const DEFAULT_KEY = '47cc575a-a2f7-4937-bbf9-7de0333a6901'; //demo api key
// const DEFAULT_KEY = 'f04731a6-1b84-4afb-91f4-d866639ea3cc'; //local api key

// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "https://demo4.infinitemlmdemo.com/krishna-murthy/backoffice/api/";
// const IMG_URL = "https://demo4.infinitemlmdemo.com/krishna-murthy/uploads/images/";
// const BASE = "https://demo4.infinitemlmdemo.com/krishna-murthy/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY
// }


// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "http://demo8.infinitemlmdemo.com/krishna-murthy/backoffice/api/";
// const IMG_URL = "http://demo8.infinitemlmdemo.com/krishna-murthy/uploads/images/";
// const BASE = "http://demo8.infinitemlmdemo.com/krishna-murthy/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY
// }


// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "https://office.inaramax.com/backoffice/api/";
// const IMG_URL = "https://office.inaramax.com/uploads/images/";
// const BASE = "https://office.inaramax.com/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY
// }

//Following is the live api config
const COMPANY_NAME =companyName.companyName??'Company Name';
const BASE_URL = "https://admin.inaramax.com/backoffice/api/";
const IMG_URL = "https://admin.inaramax.com/uploads/images/";
const BASE = "https://admin.inaramax.com/";
const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
export {
    COMPANY_NAME,
    BASE_URL,
    IMG_URL,
    API_KEY,
    BASE,
    DEFAULT_KEY
}


// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "http://192.168.9.44/WC/krishna-murthy/backoffice/api/";
// const IMG_URL = "http://192.168.9.44/WC/krishna-murthy/uploads/images/";
// const BASE = "http://192.168.9.44/WC/krishna-murthy/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY
// }




